import { Component, Input, HostListener, ViewChild, ElementRef } from '@angular/core';

import ims from '../../../imports'
import { SitesService } from '@app/services/sites.service';
import { IntegrationService } from '@app/services/integration.service';
import { StatisticsService } from 'src/app/services/statistics.service';
import { Helper } from 'src/4services/2helper';
import { lastValueFrom } from 'rxjs';
import { BaseComponent } from '@app/directives/base-component';

@Component({
    selector: 'c_card_stat_widget',
    templateUrl: './c_card_stat_widget.component.html',
    styleUrls: ['../../common.scss', './c_card_stat_widget.component.scss'],
    standalone: false
})
export class c_card_stat_widget_component extends BaseComponent {
  @Input() me;
  @Input() site;
  @ViewChild('statisticsDropdown') statisticsDropdown: ElementRef;
  @ViewChild('statisticsRangeDropdown') statisticsRangeDropdown: ElementRef;
  @ViewChild('statisticsRoleListDropdown') statisticsRoleListDropdown: ElementRef;

  //statistics
  isIncludesOtherEvents = false;
  statisticsType = {
    types: ['Event Statistics', 'Trouble Statistics'],
    curType: 'Event Statistics',
    metrics: {
      'Event Statistics': '6,11',
      'Trouble Statistics': '1,13'
    },
    dropdown: {
      isShow: false
    }
  }
  timeRangeInfo = {
    'Last 24 Hours' : {idx:0, timeGap: '1hour', timeTicks: 25, label: 'Last 24 Hours'},
    'Last 7 Days': {idx:1, timeGap: '1day', timeTicks: 8, label: 'Last 7 Days'},
    'Last 30 Days': {idx:2, timeGap: '1day', timeTicks: 31, label: 'Last 30 Days'},
    'Current Month': {idx:3, timeGap: '1day', timeTicks: 31, label: 'Current Month'},
    'Previous Month': {idx:4, timeGap: '1day', timeTicks: 31, label: 'Previous Month'},
  }
  timeRanges = Object.keys(this.timeRangeInfo).map((key) => this.timeRangeInfo[key]);

  // 두 가지 roleList를 저장
  roleListData = {
    myDealer: [],      // amIStationDealer === true일 때의 역할 목록
    partnerDealer: [], // amIStationDealer === false일 때의 역할 목록
    currentView: 'myDealer' as 'myDealer' | 'partnerDealer' // 현재 보고 있는 뷰
  }

  get isHostedStation(){
    return this.integrationService.station_hosted() ? true : false
  }

  // 현재 선택된 roleList (Computed property)
  get roleList() {
    return this.roleListData.currentView === 'myDealer'
      ? this.roleListData.myDealer
      : this.roleListData.partnerDealer;
  }

  // amIStationDealer 플래그 (Computed property)
  get amIStationDealer(): boolean {
    return this.site?.partner_id == this.me?.dealer_id;
  }

  // 두 리스트가 모두 사용 가능한지 확인
  get hasBothRoleLists(): boolean {
    return this.roleListData.myDealer.length > 0 &&
           this.roleListData.partnerDealer.length > 0;
  }

  staticsticsData = {
    dropdown: {
      isShow: false
    },
    roleDropdown: { isShow: false },
    timeData: {
      range: 'Last 30 Days',
      rangeIdx: 1,
    },
    roleData: {
      range: 'All',
      value: 0,
      viewType: 'myDealer' as 'myDealer' | 'partnerDealer'
    },
    monitoringTimeStat: {
      status: 0,
      count: <any>0,
      max: <any>0,
      updates: 0,
      range: 'Last 30 Days',
      rangeLabel : 'Last 30 Days',
      rangeIdx: 1,
      stime: '',
      etime: '',
      total: '',
      avg: '',
      counts: '',
      chartData: {
        title: '',
        data: {},
        labels: [],
        topItems: [],
        isReady: false
      },
      eventData: [
        { data: new Array(25).fill(0), label: 'Last 24 Hours' }, // per 1 hour
        { data: new Array(8).fill(0), label: 'Last 7 Days' }, // per 12 hour
        { data: new Array(31).fill(0), label: 'Last 30 Days' }, // pser 1 day
        { data: new Array(31).fill(0), label: 'Current Month' }, // per 1 days
        { data: new Array(31).fill(0), label: 'Previous Month' }, // per 1 days
      ],
      _topItems: [],
      topItems: [],
      isLoading: false,
      isHovered: false,
      hoverLabel: '',
      labelType: 'time'
    },
    videoEvents: {
      status: 0,
      count: 0,
      max:0,
      updates: 0,
      range: 'Last 30 Days',
      rangeLabel : 'Last 30 Days',
      rangeIdx: 1,
      stime: '',
      etime: '',
      chartData: {
        data: {},
        labels: [],
      },
      eventData: [
        { data: new Array(25).fill(0), label: 'Last 24 Hours' }, // per 1 hour
        { data: new Array(8).fill(0), label: 'Last 7 Days' }, // per 12 hour
        { data: new Array(31).fill(0), label: 'Last 30 Days' }, // pser 1 day
        { data: new Array(31).fill(0), label: 'Current Month' }, // per 1 days
        { data: new Array(31).fill(0), label: 'Previous Month' }, // per 1 days
      ],
      _topItems: [],
      topItems: [],
      isLoading: false,
      isHovered: false,
      hoverLabel: '',
    },
    // Trouble
    offlineEvents: {
      status: 0,
      count: 0,
      max:0,
      updates: 0,
      range: 'Last 30 Days',
      rangeLabel : 'Last 30 Days',
      rangeIdx: 1,
      stime: '',
      etime: '',
      chartData: {
        data: {},
        labels: [],
      },
      eventData: [
        { data: new Array(25).fill(0), label: 'Last 24 Hours' }, // per 1 hour
        { data: new Array(8).fill(0), label: 'Last 7 Days' }, // per 12 hour
        { data: new Array(31).fill(0), label: 'Last 30 Days' }, // pser 1 day
        { data: new Array(31).fill(0), label: 'Current Month' }, // per 1 days
        { data: new Array(31).fill(0), label: 'Previous Month' }, // per 1 days
      ],
      _topItems: [],
      topItems: [],
      isLoading: false,
      isHovered: false,
      hoverLabel: '',
    },
    bypassEvents: {
      status: 0,
      count: 0,
      max:0,
      updates: 0,
      range: 'Last 30 Days',
      rangeLabel : 'Last 30 Days',
      rangeIdx: 1,
      stime: '',
      etime: '',
      chartData: {
        data: {},
        labels: [],
      },
      eventData: [
        { data: new Array(25).fill(0), label: 'Last 24 Hours' }, // per 1 hour
        { data: new Array(8).fill(0), label: 'Last 7 Days' }, // per 12 hour
        { data: new Array(31).fill(0), label: 'Last 30 Days' }, // pser 1 day
        { data: new Array(31).fill(0), label: 'Current Month' }, // per 1 days
        { data: new Array(31).fill(0), label: 'Previous Month' }, // per 1 days
      ],
      _topItems: [],
      topItems: [],
      isLoading: false,
      isHovered: false,
      hoverLabel: '',
    },
  }

  constructor(
    private sitesService: SitesService,
    private integrationService: IntegrationService,
    private statisticsService: StatisticsService,
    private helper: Helper,
  ) { super(); }

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (this.statisticsDropdown && !this.statisticsDropdown.nativeElement.contains(event.target)) this.statisticsType.dropdown.isShow = false;
    if (this.statisticsRangeDropdown && !this.statisticsRangeDropdown.nativeElement.contains(event.target)) this.staticsticsData.dropdown.isShow = false;
    if (this.statisticsRoleListDropdown && !this.statisticsRoleListDropdown.nativeElement.contains(event.target)) this.staticsticsData.roleDropdown.isShow = false;
  }

  async ngOnInit(){
    await this.init();
  }

  async ngOnChanges(changes){
    if(!changes?.site) return;
    if(!changes.site?.previousValue?.site_id) return; // 이미 init에서 실행됨.
    if(changes.site?.previousValue?.site_id === changes.site?.currentValue?.site_id) return;
    await this.init();
  }

  async init(){
    // roleList 초기화 (getter이므로 직접 할당 불가)
    this.roleListData.myDealer = [];
    this.roleListData.partnerDealer = [];
    await this.getMemberRoleList();
    await this.getSiteStatistics();
  }

  // -------------------------------------------
  // On Chart Event Handler
  onChartReady(event, chartData) {
    chartData.isReady = event;
  }

  toggleStatisticsDropDownMenu() {
    this.statisticsType.dropdown.isShow = !this.statisticsType.dropdown.isShow;
  }

  async changeStatisticsType(type) {
    const statisticsType = this.statisticsType;
    statisticsType.curType = type;
    this.isIncludesOtherEvents = false;
    await this.getSiteStatistics();
    this.statisticsType.dropdown.isShow = false;
  }

  toggleStatisticsRangeDropDownMenu() {
    this.staticsticsData.dropdown.isShow = !this.staticsticsData.dropdown.isShow;
  }

  toggleStatisticsRoleListDropDownMenu() {
    this.staticsticsData.roleDropdown.isShow = !this.staticsticsData.roleDropdown.isShow;
  }

  async changeStatisticsTimeRange(label) {
    const alarmTimeData = this.staticsticsData.timeData;
    const selTimeInfo = ims._.cloneDeep(this.timeRangeInfo[label]);
    if (alarmTimeData.range !== label) {
      alarmTimeData.range = selTimeInfo.label;
      alarmTimeData.rangeIdx = selTimeInfo.idx;
      await this.getSiteStatistics();
      this.staticsticsData.dropdown.isShow = false;
    }
  }

  async changeMonitoringRoleId(value) {
    const roleData = this.staticsticsData.roleData;
    const selRoleInfo = this.roleList.find(role => role.value === value);
    if (roleData.value !== value) {
      roleData.range = selRoleInfo.label;
      roleData.value = selRoleInfo.value;
      roleData.viewType = this.roleListData.currentView; // viewType 동기화 추가
      await this.getSiteStatistics();
      this.staticsticsData.roleDropdown.isShow = false;
    }
  }

  changeIsIncluded() {
    this.getSiteStatistics();
  }

  // UI 바인딩용 computed property
  get isViewingPartnerDealer(): boolean {
    return this.roleListData.currentView === 'partnerDealer';
  }

  set isViewingPartnerDealer(value: boolean) {
    this.roleListData.currentView = value ? 'partnerDealer' : 'myDealer';
  }

  // 뷰 전환 핸들러
  async changeDealerView() {
    // 현재 선택된 뷰 타입 업데이트
    this.staticsticsData.roleData.viewType = this.roleListData.currentView;

    // roleData 초기화 (새로운 roleList의 기본값으로)
    this.setDefaultRoleData();

    // 통계 데이터 다시 로드
    await this.getSiteStatistics();
  }

  hasReadRolePermission = false;

  async getMemberRoleList() {
    // Permission 체크
    await this.helper.permission.load_my_permissions_only_if_not_loaded();
    this.hasReadRolePermission = this.helper.permission.has('dealer_role_update');
    if (!this.hasReadRolePermission) return;

    // 두 가지 roleList를 모두 로드
    await Promise.all([
      this.loadMyDealerRoles(),
      this.loadPartnerDealerRoles()
    ]);

    // 기본 뷰 설정: isHostedStation이 true이면 'myDealer', 아니면 amIStationDealer에 따라 자동 선택
    if (this.isHostedStation) {
      this.roleListData.currentView = 'myDealer';
    } else {
      this.roleListData.currentView = this.amIStationDealer ? 'myDealer' : 'partnerDealer';
    }

    // 기본 roleData 설정
    this.setDefaultRoleData();
  }

  async loadMyDealerRoles() {
    try {
      const res = await this.helper.dealer_role.get_roles();
      this.roleListData.myDealer = this.buildRoleList(res);
    } catch (err) {
      console.debug('Failed to load my dealer roles', err);
      this.roleListData.myDealer = [];
    }
  }

  async loadPartnerDealerRoles() {
    try {
      const res = await this.helper.dealer_role.get_roles_by_site(
        this.site.site_id,
        this.site.partner_id
      );
      this.roleListData.partnerDealer = this.buildRoleList(res);
    } catch (err) {
      console.debug('Failed to load partner dealer roles', err);
      this.roleListData.partnerDealer = [];
    }
  }

  buildRoleList(roles: any[]): any[] {
    const roleList = roles.map(role => ({
      value: role.role_id,
      label: role.name
    }));

    // "All" 옵션 추가
    const allRoleIds = roles.map(role => role.role_id).join(',');
    roleList.unshift({
      value: allRoleIds,
      label: 'All'
    });

    return roleList;
  }

  setDefaultRoleData() {
    const currentRoleList = this.roleList;
    const mpPermissionGroup = currentRoleList.find(v => v.label === 'Monitoring Operator');

    this.staticsticsData.roleData = {
      range: mpPermissionGroup ? 'Monitoring Operator' : 'All',
      value: mpPermissionGroup?.value || currentRoleList[0]?.value || 0,
      viewType: this.roleListData.currentView
    };
  }

  // CHEKT-2911: roleData.value 는 role_id, 'All' 의 콤마 결합 문자열, 또는 역할 목록을 못 읽었을 때
  // (dealer_role_update 없음) 초기값 0 이다. 0 을 그대로 보내면 V2 API 가 role_id IN (0) 으로
  // 해석해 항상 빈 결과가 되므로, 그 경우 role_ids 를 보내지 않는다 (사이트 범위 전체 역할).
  resolveSiteRoleIds(): string | null {
    const value = this.staticsticsData?.roleData?.value;
    if (value === undefined || value === null) return null;
    const str = String(value).trim();
    if (str === '' || str === '0') return null;
    return str;
  }

  async getSiteStatistics() {
    const dealerId = this.me.dealer_id;
    const siteId = this.site.site_id;
    const roleIds = this.resolveSiteRoleIds();
    const { stime, etime } = this.setMonitoringPeriod();

    // call API options.
    const curType = this.statisticsType.curType;
    let types = this.statisticsType.metrics[curType];
    let splitedTypes = types?.split(',').slice(0,2)
    this.isIncludesOtherEvents ? types += ',18,20,21' : types = splitedTypes.join(',');
    const sTimestamp = stime.unix();

    // Site Statistics Data
    const res = await lastValueFrom(this.sitesService.getSiteStatistics(dealerId, siteId, sTimestamp, etime, types))
    if (this.statisticsType.curType === this.statisticsType.types[0]) {
      this.parseVideoEvents(res);
    } else if (this.statisticsType.curType === this.statisticsType.types[1]) {
      this.parseTroubleStatistics(res);
    }

    // Monitoring Open Time
    const totalMPOpenTimeAvg = lastValueFrom(this.statisticsService.getStatisticsMPOpenTimePerSiteByPermission(dealerId, siteId, sTimestamp, etime, roleIds))
    const top10MPOpenTimeAvg = lastValueFrom(this.statisticsService.getStatisticsMPOpenTimeRankPerSiteByPermission(dealerId, siteId, sTimestamp, etime, roleIds))
    const [
      totalMPOpenTimeAvgResult, 
      top10MPOpenTimeAvgResult
    ] = await Promise.all([
      totalMPOpenTimeAvg,
      top10MPOpenTimeAvg
    ]);
    this.parseMonitoringTimeData(totalMPOpenTimeAvgResult[0], top10MPOpenTimeAvgResult)
  }

  setMonitoringPeriod(){
    const oneDayAgo = ims.moment().subtract(1, 'days').startOf('hour');
    const weekAgo = ims.moment().subtract(7, 'days').startOf('day'); // per 12hours
    const monthAgo = ims.moment().subtract(30, 'days').startOf('day'); // per 1day
    const currentMonth = ims.moment().startOf('month'); // per 1day
    const previousMonth = ims.moment().subtract(1, 'months').startOf('month'); // per 1day
    let stime = oneDayAgo; // init
    let etime = ims.moment().unix();
    let days = 0;

    // call API options.
    let targetTimeData: any = this.staticsticsData.timeData;
    if (targetTimeData.range === 'Last 24 Hours') {
      stime = oneDayAgo;
    } else if (targetTimeData.range === 'Last 7 Days') {
      stime = weekAgo;
    } else if (targetTimeData.range === 'Last 30 Days') {
      stime = monthAgo;
    } else if (targetTimeData.range === 'Current Month') {
      stime = currentMonth;
      etime = ims.moment().endOf('month').unix();
      days = ims.moment().daysInMonth();
    } else if (targetTimeData.range === 'Previous Month') {
      stime = previousMonth;
      etime = ims.moment().subtract(1, 'months').endOf('month').unix();
      days = ims.moment().subtract(1, 'months').daysInMonth();
    }

    return { stime, etime };
  }

  parseVideoEvents(data) {
    const statisticsData = this.staticsticsData;
    const videoEvents = statisticsData.videoEvents;
    
    const { targetCountData, topItemData } = this.parseConcatAllVideoEvents(data) 
    const logs = this.parseRefineChartData(videoEvents, targetCountData, topItemData, data.devices);
    this.parseAlarmData('Video Events', videoEvents, logs);
  }

  parseConcatAllVideoEvents(data){
    const videoEvents = data.video_event_count ?? {}
    const videoEventsTopDevices = data.video_event_count_top_device ?? {}
    
    const disarmedVideoEvents = data?.disarmed_video_event_count ?? {}
    const disarmedVideoEventTopDevices = data?.disarmed_video_event_count_top_device ?? {}
    
    const timelapseEvents = data?.timelapse_count ?? {}
    const timelapseEventsTopDevices = data?.timelapse_count_top_device ?? {}
    
    if(!this.isIncludesOtherEvents) {
      return { targetCountData: videoEvents || {} , topItemData: videoEventsTopDevices || {} }
    }
    
    // events
    let events = {...videoEvents}
    let topEvents = {}
    for(const timestamp in disarmedVideoEvents) {
      let target = videoEvents[timestamp]
      if(!target) {
        events[timestamp] = disarmedVideoEvents[timestamp]
        continue;
      }
      events[timestamp] = parseInt(target) + parseInt(disarmedVideoEvents[timestamp])
    }
    for(const timestamp in timelapseEvents) {
      let target = videoEvents[timestamp]
      if(!target) {
        events[timestamp] = parseInt(timelapseEvents[timestamp])
        continue;
      }
      events[timestamp] = parseInt(target) + parseInt(timelapseEvents[timestamp])
    }

    // top Events
    topEvents = this.mergeMultipleEvents(videoEventsTopDevices, disarmedVideoEventTopDevices, timelapseEventsTopDevices)
    return { targetCountData: events, topItemData: topEvents}
  }
  mergeMultipleEvents(base: EventMap, ...others: EventMap[]): EventMap {
    // base 복사해서 시작 (원본 유지)
    const result: EventMap = { ...base };

    for (const events of others) {
      for (const timestamp in events) {
        if (!result[timestamp]) {
          // timestamp 자체가 없으면 새 배열 추가
          result[timestamp] = [...events[timestamp]];
        } else {
          // timestamp 있으면 device_id 기준 병합
          const baseArr = result[timestamp];
          const map = new Map<number, EventItem>(baseArr.map(e => [e.device_id, e]));

          for (const ev of events[timestamp]) {
            if (map.has(ev.device_id)) {
              map.get(ev.device_id)!.value += ev.value; // 누적
            } else {
              baseArr.push({ ...ev }); // 새로 추가
            }
          }
        }
      }
    }

    return result;
  }

  parseMonitoringTimeData(monitoringTotalTime, monitoringTotalTimeTopItems) {
    const totalTime = monitoringTotalTime?.open_time_sum || 0;
    const totalTimeStr = this.parseTimeFormat(totalTime)
    const totalCount = monitoringTotalTime?.count || 0;
    const avgTime = Math.round(totalTime / totalCount) || 0;
    const avgTimeStr = this.parseTimeFormat(avgTime)
    const timeStatistics = this.staticsticsData.monitoringTimeStat;
    timeStatistics.total = totalTimeStr;
    timeStatistics.avg = avgTimeStr;
    timeStatistics.counts = totalCount;

    // Total Time
    const topItems = ims._.cloneDeep(monitoringTotalTimeTopItems);
    const labels = [];
    const timeData = [];
    const countData = [];
    let sumSiteTime = 0;
    let sumSiteCount = 0;

    topItems.forEach(item => {
      const seconds = parseInt(item?.open_time_sum+'');
      const count = parseInt(item.count+'');
      const name = item?.lastname ? `${item?.firstname} ${item?.lastname}` : `${item?.firstname}`
      const isNoEmail = !item?.email ? ' (IP User)' : '';
      item.name = name + isNoEmail;
      item.count = count;
      item.value = this.parseTimeFormat(item?.open_time_sum);
      item.avg = this.parseTimeFormat(item?.open_time_avg);
      item.isSiteLevel = true;

      labels.push(item.name);
      timeData.push(seconds);
      countData.push(count);
      sumSiteTime += seconds;
      sumSiteCount += count;
    })

    timeStatistics.status = 0;
    timeStatistics.chartData.title = 'Most Active Users';
    timeStatistics.chartData.data = timeData;
    timeStatistics.chartData.labels = labels;
    timeStatistics.chartData.topItems = topItems;
    timeStatistics.updates += 1;
    timeStatistics.status = 1;
    console.debug('info',timeStatistics.chartData)
  }


  parseTroubleStatistics(data) {
    const statisticsData = this.staticsticsData;
    const offlineEvents = statisticsData.offlineEvents;
    const bypassEvents = statisticsData.bypassEvents;
    this.parseOfflineEvents(offlineEvents, data);
    this.parseBypassEvents(bypassEvents, data);
  }

  parseOfflineEvents(statistics, data) {
    const targetCountData = data.offline_count || {};
    const topItemData = data.offline_count_top_device || {};
    const logs = this.parseRefineChartData(statistics, targetCountData, topItemData, data.devices);
    this.parseAlarmData('Offline Events', statistics, logs);
  }

  parseBypassEvents(statistics, data) {
    const targetCountData = data.zone_bypass_event_count || {};
    const topItemData = data.zone_bypass_event_count_top_device || {};
    const logs = this.parseRefineChartData(statistics, targetCountData, topItemData, data.devices);
    this.parseAlarmData('Bypass Events', statistics, logs);
  }

  onChartHover(event, targetChart) {
    targetChart.isHovered = true;
    targetChart.hoverLabel = this.numberWithCommas(event);
    if (targetChart.labelType === 'time') {
      targetChart.hoverLabel  = this.parseTimeFormat(event);
    }
  }

  onChartMouseOut(targetChart) {
    targetChart.isHovered = false;
    targetChart.hoverLabel = '';
  }

  parseRefineChartData(targetData, targetCountData, topItemData={}, itemData: Array<any>=[]) {
    targetData.topItems = topItemData;
    const topItems = [];
    const logs = [];
    const itemObject = {};
    itemData.forEach(item => {
      if (item.device_id) {
        itemObject[item.device_id] = item;
      } else if (item.id) {
        itemObject[item.id] = item;
      }
    })

    const timeItems = Object.keys(topItemData);
    timeItems.forEach(timestamp => {
      const items = topItemData[timestamp]
      items.forEach(item => {
        let itemInfo:any = {};
        item.name = '';
        if (item.device_id) {
          itemInfo = itemObject[item.device_id+''];
          if (itemInfo) {
            item.name = itemInfo.name ? itemInfo.name : 'No Name';
            if (itemInfo.type === 11) {
              item.name += ` (ID: ${itemInfo.zone_number})`
            }
            if (itemInfo.type === 12) {
              item.name += ` (Zone: ${itemInfo.zone_number})`
            }

          } else {
            item.name = `Deleted Device`;
          }
        }
      });
      topItems.push({
        timestamp: parseInt(timestamp),
        items: items
      });
    })

    const records = Object.keys(targetCountData);
    records.forEach(timestamp => {
      logs.push({
        timestamp: parseInt(timestamp),
        count: parseInt(targetCountData[timestamp])
      });
    })
    targetData._topItems = topItems
    return logs;
  }

  parseAlarmData(category, targetData, data) {
    targetData.isLoading = true;
    const chartData = targetData.chartData;
    const timeData = this.staticsticsData.timeData;
    let etime = ims.moment().unix();
    const oneDayAgo = ims.moment().subtract(1, 'days').startOf('hour');
    const weekAgo = ims.moment().subtract(7, 'days').startOf('day'); // per 12hours
    const monthAgo = ims.moment().subtract(30, 'days').startOf('day'); // per 1day
    const currentMonth = ims.moment().startOf('month'); // per 1day
    const previousMonth = ims.moment().subtract(1, 'months').startOf('month'); // per 1day
    let stime = oneDayAgo; // init
    let days = 0;

    if (timeData.range === 'Last 24 Hours') {
      stime = oneDayAgo;
    } else if (timeData.range === 'Last 7 Days') {
      stime = weekAgo;
    } else if (timeData.range === 'Last 30 Days') {
      stime = monthAgo;
    } else if (timeData.range === 'Current Month') {
      stime = currentMonth;
      etime = ims.moment().endOf('month').unix();
      days = ims.moment().daysInMonth();
    } else if (timeData.range === 'Previous Month') {
      stime = previousMonth;
      etime = ims.moment().subtract(1, 'months').endOf('month').unix();
      days = ims.moment().subtract(1, 'months').daysInMonth();
    }
    const sTimestamp = stime.unix();
    const timeRangeData = this.timeRangeInfo[timeData.range];
    const timeTicks = days || timeRangeData.timeTicks;
    const timeGap = timeRangeData.timeGap;
    const topItems = targetData._topItems || [];
    setTimeout(()=> {
      chartData.data = this.calcChartTime(data, sTimestamp, timeTicks, timeGap);
      targetData.topItems = this.calcTopItems(topItems, sTimestamp, timeTicks, timeGap);
      targetData.count = this.numberWithCommas(chartData.data.reduce((a, b) => a + b, 0));
      targetData.max = Math.max(...chartData.data);
      this.parseChartData(category, chartData.data, stime, etime, targetData, timeGap, timeTicks);
      targetData.updates += 1;
      targetData.isLoading = false;
    }, 100)
  }

  calcChartTime(data, stimestamp, timeTicks, timeType) {
    const arrData = new Array(timeTicks).fill(null);
    let timegapOffset = 3600;
    if (timeType === '1hour') {
      timegapOffset = 3600;
    } else if (timeType === '12hours') {
      timegapOffset = 43200;
    } else if (timeType === '1day') {
      timegapOffset = 86400;
    } else if (timeType === '7day') {
      timegapOffset = 86400 * 7;
    } else if (timeType === '30day') {
      timegapOffset = 86400 * 30;
    }
    const now = ims.moment().unix();
    for (let i = 0; i < timeTicks; i++) {
      if (now < stimestamp + i * timegapOffset) continue;
      let prevIdx = i;
      let curIdx = i + 1;
      arrData[i] = 0;
      data.forEach(record => {
        const timestamp = parseInt(record.timestamp+'');
        if (timestamp >= stimestamp + (prevIdx * timegapOffset) && timestamp < stimestamp + (curIdx * timegapOffset)) {
          arrData[i] += parseInt(record.count);
        }
      });
    }

    return arrData;
  }

  calcTopItems(data, stimestamp, timeTicks, timeType) {
    const arrData = new Array(timeTicks).fill([]);
    let timegapOffset = 3600;
    if (timeType === '1hour') {
      timegapOffset = 3600;
    } else if (timeType === '12hours') {
      timegapOffset = 43200;
    } else if (timeType === '1day') {
      timegapOffset = 86400;
    } else if (timeType === '7day') {
      timegapOffset = 86400 * 7;
    } else if (timeType === '30day') {
      timegapOffset = 86400 * 30;
    }

    for (let i = 0; i < timeTicks; i++) {
      let prevIdx = i;
      let curIdx = i + 1;
      arrData[i] = [];

      data.forEach(record => {
        const timestamp = parseInt(record.timestamp+'');
        if (timestamp >= stimestamp + (prevIdx * timegapOffset) && timestamp < stimestamp + (curIdx * timegapOffset)) {
          if (arrData[i].length == 0) {
            arrData[i] = ims._.cloneDeep(record.items);
          } else {
            record.items.forEach(item => {
              item.value = parseInt(item.value+'');
              const _item = arrData[i].find(s => s.device_id === item.device_id) || null;
              if (_item) {
                _item.value = parseInt(_item.value+'') + parseInt(item.value+'');
              } else {
                arrData[i].push(ims._.cloneDeep(item))
              }
            });
          }
        }
        arrData[i].sort((a, b) => a.value - b.value).reverse();
      });
    }
    return arrData;
  }

  parseChartData(category, data, stime, etime, targetData, timeType, timeTicks) {
    const chartData  = targetData.chartData;
    const topItems  = targetData.topItems || [];
    
    let labels = [];
    if (timeType === '1hour') {
      labels = [...Array(timeTicks)].map((x, i) => ims._.cloneDeep(stime).add(i,'hour').format('DD MMMM YYYY, hh A'));
    } else if (timeType === '12hours') {
      labels = [...Array(timeTicks)].map((x, i) => {
        const startHour = ims._.cloneDeep(stime).add(i*12,'hour').hours();
        let startHourStr = '';
        let endHourStr = '';
        if (startHour < 12) {
          startHourStr = ' - AM (00 - 12PM)';
          endHourStr = ' - PM (12PM - 24PM)';
        } else {
          startHourStr = ' - PM (12PM - 24PM)';
          endHourStr = ' - AM (00 - 12PM)';
        }
        return ims._.cloneDeep(stime).add(i*12,'hour').format('DD MMM YYYY') + startHourStr;
        // return ims._.cloneDeep(stime).add(i*12,'hour').format('DD MMM YYYY') + startHourStr + ' / ' + ims._.cloneDeep(stime).add((i+1)*12,'hour').format('DD MMM YYYY') + endHourStr
      });
    } else if (timeType === '1day') {
      labels = [...Array(timeTicks)].map((x, i) => ims._.cloneDeep(stime).add(i,'day').format('DD MMMM YYYY'));
    } else if (timeType === '7day') {
      labels = [...Array(timeTicks)].map((x, i) => ims._.cloneDeep(stime).add(i*7,'day').format('DD MMM YYYY') + ' - ' + ims._.cloneDeep(stime).add((i+1)*7,'day').format('DD MMM YYYY'));
    } else if (timeType === '30day') {
      labels = [...Array(timeTicks)].map((x, i) => ims._.cloneDeep(stime).add(i*30,'day').format('DD MMM YYYY') + ' - ' + ims._.cloneDeep(stime).add((i+1)*30,'day').format('DD MMM YYYY'));
    }

    const calandarOption = {
      sameDay: '[Today], h:mm A',
      nextDay: '[Tomorrow], h:mm A',
      nextWeek: 'MM/DD/yyyy',
      lastDay: '[Yesterday], h:mm A',
      lastWeek: '[Last] dddd',
    };
    targetData.stime = stime.calendar(null, calandarOption);
    targetData.etime =  ims.moment.unix(etime).calendar(null, calandarOption);

    chartData.data = { data: data, label: category, topSites: topItems};
    chartData.labels = labels;
    setTimeout(() => {
      targetData.status = 1;
    }, 10);
  }

  numberWithCommas(x) {
    if (!x) return '0';
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  parseTimeFormat(intTime) {
    let time = Math.round(intTime);
    let hours: any   = Math.floor(time / 3600);
    let minutes: any = Math.floor((time - (hours * 3600)) / 60);
    let seconds: any = time - (hours * 3600) - (minutes * 60);

    let timeFormat = `${seconds}s`;

    if (minutes > 0) {
      if (seconds < 10) { seconds = '0' + seconds; }
      timeFormat = `${minutes}m ${seconds}s`;
    }
    if (hours > 0) {
      if (minutes < 10) { minutes = '0' + minutes; }
      timeFormat = `${hours}h ${minutes}m`;
    }
    return timeFormat
  }
}


interface EventItem {
  device_id: number;
  value: number;
}

type EventMap = Record<string, EventItem[]>;